import { render, staticRenderFns } from "./UserLoginReset.vue?vue&type=template&id=78820cca&"
import script from "./UserLoginReset.vue?vue&type=script&lang=js&"
export * from "./UserLoginReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserLoginReset.vue"
export default component.exports